var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _g2, _g3, _g4, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 105,
    viewBox: "0 0 98 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M49 104.354C76.062 104.354 98 101.566 98 98.1268C98 94.6878 76.062 91.8999 49 91.8999C21.938 91.8999 0 94.6878 0 98.1268C0 101.566 21.938 104.354 49 104.354Z",
    fill: "#C9D3DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4879 14.4673H12.7129V72.1454H87.4879V14.4673Z",
    fill: "#C9D3DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M81.9104 18.7686H18.29V67.842H81.9104V18.7686Z",
    fill: "#29333D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2111 44.0869H66.1631V67.8444H69.2111V44.0869Z",
    fill: "#C9D3DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.0259 14.4673H83.1822V14.9286L73.1041 32.0966H67.9973L63.0259 14.4673Z",
    fill: "#29333D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8937 34.2851L34.9219 36.6094L50.7 49.9949L52.6718 47.6707L36.8937 34.2851Z",
    fill: "#C9D3DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5107 42.8044L66.8667 45.3711L82.3594 55.2943L84.0034 52.7277L68.5107 42.8044Z",
    fill: "#C9D3DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2399 68.0003H45.1919V54.6263L54.6848 42.5627H66.163V28.3027H69.2111V45.6108H56.1652L48.2399 55.682V68.0003Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4321 36.9739H16.9819V33.9259H34.3841V17.272H37.4321V36.9739Z",
    fill: "#C9D3DB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3163 29.0279H35.9082V25.9799H52.2683V17.272H55.3163V29.0279Z",
    fill: "#C9D3DB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.1359 47.8599L41.7079 50.2055L38.7701 55.9642L41.7079 57.199L34.198 72.1453H20.4751L21.8958 59.2325L24.0441 55.5763L29.408 47.8599H34.96H37.1359Z",
    fill: "#29333D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6864 39.9307C73.5438 39.9307 78.2922 35.1552 78.2922 29.2642C78.2922 23.3732 73.5438 18.5977 67.6864 18.5977C61.829 18.5977 57.0806 23.3732 57.0806 29.2642C57.0806 35.1552 61.829 39.9307 67.6864 39.9307Z",
    fill: "#DA0901"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6738 25.5054L67.7947 29.5117M67.7947 29.5117L71.9156 33.5181M67.7947 29.5117L71.9156 25.5054M67.7947 29.5117L63.6738 33.5181",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6334 18.2856H18.0396V30.6698H43.6334V18.2856Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6334 30.6694H18.0396V43.4664H43.6334V30.6694Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6334 43.4663H18.0396V55.8504H43.6334V43.4663Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6334 55.8506H18.0396V68.6475H43.6334V55.8506Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0155 27.5754C26.7268 27.5754 28.114 26.1882 28.114 24.4769C28.114 22.7657 26.7268 21.3784 25.0155 21.3784C23.3042 21.3784 21.917 22.7657 21.917 24.4769C21.917 26.1882 23.3042 27.5754 25.0155 27.5754Z",
    fill: "#C9D3DB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0155 40.199C26.7268 40.199 28.114 38.8117 28.114 37.1005C28.114 35.3892 26.7268 34.002 25.0155 34.002C23.3042 34.002 21.917 35.3892 21.917 37.1005C21.917 38.8117 23.3042 40.199 25.0155 40.199Z",
    fill: "#C9D3DB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0155 52.8225C26.7268 52.8225 28.114 51.4353 28.114 49.724C28.114 48.0127 26.7268 46.6255 25.0155 46.6255C23.3042 46.6255 21.917 48.0127 21.917 49.724C21.917 51.4353 23.3042 52.8225 25.0155 52.8225Z",
    fill: "#C9D3DB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0155 64.9865C26.7268 64.9865 28.114 63.6507 28.114 62.0028C28.114 60.3549 26.7268 59.019 25.0155 59.019C23.3042 59.019 21.917 60.3549 21.917 62.0028C21.917 63.6507 23.3042 64.9865 25.0155 64.9865Z",
    fill: "#C9D3DB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5899 21.6079H30.6387V23.4441H39.5899V21.6079Z",
    fill: "#C9D3DB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5899 34.2314H30.6387V36.0676H39.5899V34.2314Z",
    fill: "#C9D3DB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5899 46.855H30.6387V48.6911H39.5899V46.855Z",
    fill: "#C9D3DB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5899 59.249H30.6387V61.0852H39.5899V59.249Z",
    fill: "#C9D3DB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5752 24.8789H30.5371V26.8661H39.5752V24.8789Z",
    fill: "#C9D3DB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5752 37.5024H30.5371V39.4897H39.5752V37.5024Z",
    fill: "#C9D3DB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5752 50.126H30.5371V52.1132H39.5752V50.126Z",
    fill: "#C9D3DB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5752 62.3828H30.5371V64.2616H39.5752V62.3828Z",
    fill: "#C9D3DB"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4102 56.7658L29.1856 48.3218L30.6476 49.6048L24.8729 59.2561L22.4102 56.7658Z",
    fill: "#016AD4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1911 42.8589L12.442 46.6093L9.47434 48.4936L8.40479 41.9937L11.1911 42.8589Z",
    fill: "#F4A28C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38812 38.3698C8.02618 36.8114 10.0987 36.4923 11.2509 37.7226C12.5133 39.0698 14.0373 41.2158 12.3136 42.3818C9.67643 44.1674 7.25729 40.8302 7.25729 40.8302C7.25729 40.8302 6.90384 39.5518 7.38812 38.3698Z",
    fill: "#F4A28C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31597 40.6693C9.31597 40.6693 8.64118 40.1047 8.33363 40.9057C8.02837 41.709 9.22187 42.0969 9.57762 41.6907C9.93338 41.2844 9.31597 40.667 9.31597 40.667V40.6693Z",
    fill: "#F4A28C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01091 50.3346C6.90603 48.3217 8.65726 46.8138 10.7688 46.1803C14.8015 44.9684 22.2264 46.2951 24.4895 50.0661C27.588 55.2302 23.0527 71.634 23.0527 71.634L9.50189 72.6852C9.50189 72.6852 2.04712 59.2399 6.01091 50.3323V50.3346Z",
    fill: "#016AD4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0506 71.6338L21.2673 94.9323H18.4511L15.9355 76.8301L9.7041 72.6873L23.0506 71.6338Z",
    fill: "#29333D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70397 72.6875L5.81592 94.9325H8.83639L15.3616 76.4516L9.70397 72.6875Z",
    fill: "#29333D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M11.9394 45.827C11.9394 45.827 5.60011 66.2427 23.9042 67.5969L23.0504 71.6364L9.49964 72.6876C9.49964 72.6876 4.72564 65.1892 4.92762 54.6589C4.92762 54.6589 5.04238 49.4511 8.7078 47.149C8.7078 47.149 10.1079 46.1185 11.9394 45.8247V45.827Z",
    fill: "#29333D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52526 94.8843L4.70517 96.2247C4.39532 96.4542 4.55598 96.9477 4.94157 96.9477H7.99188C8.21222 96.9477 8.39124 96.7686 8.39124 96.5483V94.8843H6.52526Z",
    fill: "#016AD4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9161 94.8843L22.6283 96.2247C22.9313 96.4611 22.7638 96.9477 22.3782 96.9477H20.2069C19.5666 96.9477 19.0479 96.4289 19.0479 95.7886V94.8843H20.9138H20.9161Z",
    fill: "#016AD4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4665 46.0723C17.4665 46.0723 15.1392 49.3727 17.4665 53.2998C18.9446 55.7947 23.2435 60.6513 26.1836 63.8623C27.6135 65.4253 30.1543 65.1292 31.1871 63.2793L37.5012 52.1476L35.3575 50.7751L29.5713 59.2604C29.5713 59.2604 25.6121 46.2398 17.4665 46.0769V46.0723Z",
    fill: "#016AD4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.4665 46.0723C17.4665 46.0723 15.1392 49.3727 17.4665 53.2998C18.9446 55.7947 23.2435 60.6513 26.1836 63.8623C27.6135 65.4253 30.1543 65.1292 31.1871 63.2793L37.5012 52.1476L35.3575 50.7751L29.5713 59.2604C29.5713 59.2604 25.6121 46.2398 17.4665 46.0769V46.0723Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7529 51.668C36.7529 51.668 40.338 50.3506 38.8759 48.3239C37.4139 46.295 35.3574 50.7729 35.3574 50.7729L36.7529 51.668Z",
    fill: "#F4A28C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1007 45.3661L37.6939 44.736C37.1898 44.5102 36.5982 44.7357 36.3724 45.2398L35.0789 48.1275C34.8531 48.6315 35.0787 49.2231 35.5827 49.4489L36.9895 50.0791C37.4935 50.3048 38.0851 50.0793 38.3109 49.5752L39.6045 46.6876C39.8302 46.1835 39.6047 45.5919 39.1007 45.3661Z",
    fill: "#3D4D5C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60247 43.1874L6.59418 41.1079C6.17186 40.6718 5.95382 40.082 5.98366 39.4761C6.03186 38.418 6.25908 36.7333 7.13355 35.4664C8.50607 33.481 10.3353 32.7305 10.7898 34.4473C11.2442 36.1641 11.3383 34.126 12.4446 35.0372C13.5509 35.9483 13.3237 36.4831 12.4446 36.9674C11.5656 37.4517 9.74318 38.1494 9.58252 39.5977C9.42185 41.046 10.7921 42.2119 8.60477 43.1851L8.60247 43.1874Z",
    fill: "#29333D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5254 48.6223C29.5254 48.6223 29.973 45.526 32.9751 45.8267C35.9772 46.1251 34.8801 46.8917 33.6682 46.9491H33.659C33.1541 47.0478 32.7639 47.4265 32.6032 47.9153C32.4265 48.457 31.9376 49.1616 30.6454 49.6069L29.5254 48.6246V48.6223Z",
    fill: "#F4A28C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.1564f58573464347bac4aa4b7fe245fe.svg";
export { ForwardRef as ReactComponent };